import { interopDefault } from '~/router/utils'

export const adminReportsRoutes = [
  {
    name: '__admin_reports_search',
    path: '/admin/reports/search/',
    pathToRegexpOptions: { strict: true },
    component: () =>
      interopDefault(
        import(
          '~/pages/admin/reports/classified/search.vue' /* webpackChunkName: "pages-admin-reports-classified-search" */
        )
      )
  },
  {
    name: '__admin_message_reports_search',
    path: '/admin/reports/messages/search/',
    pathToRegexpOptions: { strict: true },
    component: () =>
      interopDefault(
        import(
          '~/pages/admin/reports/message/search.vue' /* webpackChunkName: "pages-admin-reports-message-search" */
        )
      )
  },
  {
    name: '__admin_reports_shorts',
    path: '/admin/reports/shorts/',
    pathToRegexpOptions: { strict: true },
    component: () =>
      interopDefault(
        import(
          '~/pages/admin/reports/shorts/search.vue' /* webpackChunkName: "pages-admin-reports-shorts-search" */
        )
      )
  }
]
